import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
    joinProductIf,
    initialState,
} from 'app/core/models/slice/prd/joinProduct'
import { RootState } from 'app/core/store'
import { isObject, isArray } from 'lodash'

const slice = createSlice({
    name: 'joinProduct',
    initialState,
    reducers: {
        clearJoinProduct: (state) => {
            Object.keys(initialState).map((key1) => {
                if (isObject(state[key1])) {
                    state[key1] = {}
                } else if (isArray(state[key1])) {
                    state[key1] = []
                } else {
                    state[key1] = ''
                }
            })
        },
        clearJoinProcessData: (state) => {
            state.comboFlage = false
            state.newPasswordType = ''
            state.contractSelect = ''
            state.rsrgLmtAmt = 0 //적립한도금액
            state.newAmt = 0 //신규금액
            state.arrTrm = '' //계약기간(년)
            state.lftmAcn = '' //평생계좌번호
            state.newAcn = '' //신규계좌번호
            state.iobAcn = '' //당타행계좌번호
            state.depExpiNtchDcd = '' //수신만기통보구분코드 (0:미신청 / 1:신청(휴대폰))
            state.atmtExpiTrmtAplcYn = '' //만기자동해지 신청여부
            state.expiMnrcAcn = '' //만기자동해지 입금 계좌번호
            state.atexDcd = ''
            state.attrYn = '' //자동이체 여부
            state.traCylDcd = '' //자동이체 매월 매주 매일 은행영업일 체크
            state.tranDsgtDd = '' //이체지정일 DD
            state.tranOpngYmd = '' //자동이체 등록년월일
            state.attrAcn = '' //자동이체 출금계좌번호
            state.slnmBnkbNm = '' //IBK D-day적금 셀프네이밍통장명
            state.baseAmt = '' //IBK D-day적금 목표금액
            state.frstJoinRfsnYn = '' //IBK D-day적금 우대금리가능여부
            state.lmtAcntYn = '' //한도계좌여부
            state.cnteDcd = '' //계약기간구분코드(1:년 2:개월 4:일)
            state.autoTransType = undefined //자동이체 신청타입
            state.autoTransDay = undefined //자동이체 월 > 일
            state.autoTransDayOfWeek = undefined //자동이체 매주 > 요일
            state.expireMethod = undefined //만기자동해지방법
            state.fnlcDtlDcd = '' //금융소비자상세구분코드
            state.rqstCd = '' //상품요청코드 있으면 만기예상금액버튼 show
            state.joinAmtMethod = ''
            state.outAcn = ''
            state.atmtRdpsCosnDcd = ''
            state.sido = '' // 입주희망지역 시/도
            state.gungu = '' // 입주희망지역 군/구
            state.mdlDcd = '' // 희망주택형 셋팅
            state.sqmDcd = '' // 주택면적(전용면적)
            state.mihYm = '' // 희망입주시기
            state.nextPage = '' // nextPage
        },
        setJoinProductIf: (state, action: PayloadAction<joinProductIf>) => {
            state = { ...action.payload }
        },
        setJoinProductIfCode: (state, action: PayloadAction<string>) => {
            state.allPdcd = action.payload
        },
        setPdm: (state, action: PayloadAction<string>) => {
            state.pdm = action.payload
        },
        setMngmBrcd: (state, action: PayloadAction<string>) => {
            state.mngmBrcd = action.payload
        },
        setRcndEmn: (state, action: PayloadAction<string>) => {
            state.rcndEmn = action.payload
        },
        clearMngmBrcdInfo: (state) => {
            state.mngmBrcd = ''
            state.krnBrm = ''
            state.rcndEmn = ''
            state.rcndEmnNM = ''
        },
        setHomeJoinProductIf: (state, action: PayloadAction<joinProductIf>) => {
            state.allPdcd = action.payload.allPdcd
            state.pdlnCd = action.payload.pdlnCd
            state.pdgrCd = action.payload.pdgrCd
            state.pdtmCd = action.payload.pdtmCd
            state.pdcd = action.payload.pdcd
            state.ccalCd = action.payload.ccalCd
            state.pdm = action.payload.pdm
            state.nfchOfrPdm = action.payload.nfchOfrPdm
            state.nfchPrcfGrpCd = action.payload.nfchPrcfGrpCd
            state.pdfIntcd = action.payload.pdfIntcd
            state.whbnVcd = action.payload.whbnVcd
            state.nfchPrcfGrpCdNm = action.payload.nfchPrcfGrpCdNm
            state.cardBrcoDsncNm = action.payload.cardBrcoDsncNm
            state.pdfImgUrlAdr = action.payload.pdfImgUrlAdr
            state.pdfPrmrCon = action.payload.pdfPrmrCon
            state.pdfRmrkCon = action.payload.pdfRmrkCon
        },
        setJoinProductArr: (state, action: PayloadAction<any>) => {
            action.payload.map((joinArr) => {
                state[joinArr.key] = joinArr.value
            })
        },
        setJoinProductObArr: (state, action: PayloadAction<any>) => {
            Object.keys(action.payload).map((key) => {
                Object.keys(initialState).map((key1) => {
                    if (
                        key1 === key &&
                        action.payload[key] !== '' &&
                        action.payload[key] !== undefined &&
                        action.payload[key] !== null
                    ) {
                        state[key] = action.payload[key]
                    }
                })
            })
        },
        /**
         * 당행/타행 계좌 인증 이후 계좌번호, 은행명, 은행 코드를 업데이트 한다.
         */
        setAcn: (
            state,
            action: PayloadAction<{ acn: string; bncd: string; bncdNm: string }>
        ) => {
            state.iobAcn = action.payload.acn
            state.bncd = action.payload.bncd
            state.bncdNm = action.payload.bncdNm
        },
    },
})

export const {
    clearJoinProduct,
    setJoinProductIf,
    setJoinProductIfCode,
    setPdm,
    setHomeJoinProductIf,
    setJoinProductArr,
    setJoinProductObArr,
    setMngmBrcd,
    setRcndEmn,
    clearMngmBrcdInfo,
    setAcn,
    clearJoinProcessData,
} = slice.actions

export default slice.reducer

export const selectorAllPdcd = (state: RootState) => {
    return state.joinProduct.allPdcd
}
